
import Medicine from './myMedicines/Medicine.vue'; 
import MedicineAtoZList from './myMedicines/MedicineAtoZList';
import MedicineByLetter from './myMedicines/MedicineByLetter';
import MyMedicineList from './myMedicines/MyMedicineList';
import MyReview from './myOutcomes/MyReview';

export default  {
    Medicine,
    MedicineAtoZList,
    MedicineByLetter,
    MyMedicineList,
    MyReview
};
